let config;

config = {
    apiBaseUrl: "https://migrate-videos-tool.launchyou.com",
    debug: true
};

export {config}
